"use client";
import { ReactNode } from "react";
import StarFilledIcon from "@/components/icons/StarFilledIcon";
import StarIcon from "@/components/icons/StarIcon";
import ProductFilterItem from "./ProductFilterItem";


interface RatingData {
  value: number
  label: ReactNode
}

const ratingDatas: RatingData[] = [
  {
    value: 1,
    label: (<div className="flex items-center gap-1">
      <StarFilledIcon />
      <StarIcon className="w-4 h-4 text-red-500" />
      <StarIcon className="w-4 h-4 text-red-500" />
      <StarIcon className="w-4 h-4 text-red-500" />
      <StarIcon className="w-4 h-4 text-red-500" />
    </div>)
  },
  {
    value: 2,
    label: (<div className="flex items-center gap-1">
      <StarFilledIcon />
      <StarFilledIcon />
      <StarIcon className="w-4 h-4 text-red-500" />
      <StarIcon className="w-4 h-4 text-red-500" />
      <StarIcon className="w-4 h-4 text-red-500" />
    </div>)
  },
  {
    value: 3,
    label: (<div className="flex items-center gap-1">
      <StarFilledIcon />
      <StarFilledIcon />
      <StarFilledIcon />
      <StarIcon className="w-4 h-4 text-red-500" />
      <StarIcon className="w-4 h-4 text-red-500" />
    </div>)
  },
  {
    value: 4,
    label: (
      <div className="flex items-center gap-1">
        <StarFilledIcon />
        <StarFilledIcon />
        <StarFilledIcon />
        <StarFilledIcon />
        <StarIcon className="w-4 h-4 text-red-500" />
      </div>
    )
  },
  {
    value: 5,
    label: (<div className="flex items-center gap-1">
      <StarFilledIcon />
      <StarFilledIcon />
      <StarFilledIcon />
      <StarFilledIcon />
      <StarFilledIcon />
    </div>)
  },
]


const ProductFilterRate = ({ onChange, indexActive }: { indexActive: number, onChange: (rate: number) => void }) => {

  return (
    <>
      {ratingDatas
        .map((rate, index: number) => {
          return (
            <span
              className="cursor-pointer"
              key={index}
              onClick={() => {
                if (indexActive === rate.value) {
                  onChange(0)
                } else {
                  onChange(rate.value)
                }
              }}
            >

              <ProductFilterItem active={indexActive === rate.value} >
                <div className="hover:text-red-500 ml-4">
                  {rate.label}
                </div>
              </ProductFilterItem>

            </span>
          );
        })}
    </>
  );
};

export default ProductFilterRate;
